import { useEffect, type RefObject } from 'react'

/** Adds `is-visible` to every `.reveal` descendant of `rootRef.current`
 *  the first time it enters the viewport. One observer per call. */
export function useRevealOnScroll(rootRef: RefObject<HTMLElement | null>) {
  useEffect(() => {
    const root = rootRef.current
    if (!root) return
    const targets = Array.from(root.querySelectorAll<HTMLElement>('.reveal'))
    if (targets.length === 0) return

    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible')
            io.unobserve(entry.target)
          }
        }
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 },
    )
    targets.forEach((t) => io.observe(t))
    return () => io.disconnect()
  }, [rootRef])
}
